import { useEffect, useState } from "react"
import { Button } from "../ui/button/Button"
import { reportConsentSettingsOpened } from "./beacon"
import { ConsentSettingsDialog } from "./ConsentSettingsDialog"
import { setConsentDecision } from "./consent"
import { PRIVACY_POLICY_URL } from "./constants"

export type ConsentBannerProps = {
  privacyPolicyUrl?: string
}

/**
 * Visibility is driven by the `show-cookiebanner` body class that the inline
 * `generateCookieBannerScript` adds before paint, so an already-decided visitor
 * never sees a flash of the banner.
 */
export function ConsentBanner({
  privacyPolicyUrl = PRIVACY_POLICY_URL,
}: ConsentBannerProps) {
  const [isMounted, setIsMounted] = useState(false)
  const [isSettingsOpen, setIsSettingsOpen] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <>
      <div
        className="fixed bottom-0 left-0 right-0 border border-solid border-border-default border-b-0 p-4 rounded-tl-2xl rounded-tr-2xl overflow-hidden text-fg-default hidden z-[var(--banner-z-index)] [.show-cookiebanner_&]:block bg-bg-surface"
        id="cookie-banner"
        style={
          { "--banner-z-index": Number.MAX_SAFE_INTEGER } as React.CSSProperties
        }
      >
        <div className="relative mx-auto justify-between flex md:flex-row flex-col md:items-center gap-4">
          <p className="text-sm">
            Cookies help us keep making our site better for you. By continuing
            to browse, you agree to our{" "}
            <a
              href={privacyPolicyUrl}
              className="underline text-sm text-fg-secondary"
            >
              privacy policy
            </a>
            .
          </p>
          <div className="flex md:flex-row flex-col gap-2 md:justify-between flex-shrink-0">
            <Button
              className="w-full md:w-auto"
              isDisabled={!isMounted}
              onPress={() => {
                reportConsentSettingsOpened()
                setIsSettingsOpen(true)
              }}
            >
              Manage settings
            </Button>
            <Button
              className="w-full md:w-auto"
              variant="solid"
              color="success"
              isDisabled={!isMounted}
              onPress={() => setConsentDecision("accepted", "banner")}
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
      <ConsentSettingsDialog
        isOpen={isSettingsOpen}
        onOpenChange={setIsSettingsOpen}
      />
    </>
  )
}
